import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { TranslatePipe } from '@ngx-translate/core';

import { AuthState } from '@data/state';

const MS_PER_DAY = 1000 * 60 * 60 * 24;
const URGENT_THRESHOLD_DAYS = 3;

@Component({
  selector: 'app-trial-banner',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './trial-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialBannerComponent {
  private readonly _store = inject(Store);

  private readonly _isTrial = this._store.selectSignal(AuthState.isTrial);
  private readonly _trialEndDate = this._store.selectSignal(AuthState.trialEndDate);

  readonly daysRemaining = computed(() => {
    const endDate = this._trialEndDate();
    if (!endDate) return null;
    const diffMs = new Date(endDate).getTime() - Date.now();
    return Math.ceil(diffMs / MS_PER_DAY);
  });

  readonly visible = computed(
    () => this._isTrial() && this.daysRemaining() !== null && this.daysRemaining()! >= 0,
  );

  readonly urgent = computed(() => (this.daysRemaining() ?? Infinity) <= URGENT_THRESHOLD_DAYS);
}
